/* eslint-disable prefer-const */

export const appendDescription = (formData, descriptionToBeAdded, addLeading = false) => {
  if (!formData.description) {
    formData.description = `${descriptionToBeAdded}`;
  } else {
    let newDescription;
    if (!addLeading) {
      newDescription = `${formData.description} - ${descriptionToBeAdded}`;
    } else {
      newDescription = `${descriptionToBeAdded} - ${formData.description}`;
    }
    formData.description = newDescription;
  }
};

export const formatAddress = (data, defaultProvince) => {
  let address = {
    streetNumber: data.address?.addressObj?.street || 'Unknown',
    streetName: data.address?.addressObj?.streetName || 'Unknown',
    city: data.address?.addressObj.country === 'Canada' ? (data.address?.addressObj?.city || 'Unknown') : formatAddressString([data.address?.addressObj?.city, data.address?.addressObj?.provinceState, data.address?.addressObj?.postalCode]),
    countryCode: 'CA',
    provinceCode: data.address?.addressObj.country === 'Canada' ? (data.address?.addressObj?.provinceState || defaultProvince) : defaultProvince,
    postalCode: data.address?.addressObj.country === 'Canada' ? (data.address?.addressObj?.postalCode || 'X0X 0X0') : 'X0X 0X0',
  };
  return address;
};

export const changePhoneNumberFormat = (phoneNumber) => {
  if (phoneNumber && typeof phoneNumber === 'string' && phoneNumber.indexOf('(') > -1) {
    return phoneNumber.replace('(', '').replace(') ', '-');
  }
  return phoneNumber;
};

export const formatPhoneNumber = (data) => {
  let { number } = data;
  number = changePhoneNumberFormat(number);
  data.phoneNumber = {
    code: 'CA',
    number: number || '999-999-9999',
  };
  delete data.number;
};

// Set action according to existense of id
export const setAction = (object) => {
  if (object.id) {
    object.action = 'patch';
    delete object.temporaryId;
    delete object.policySystemId;
  } else {
    object.action = 'post';
    delete object.id;
  }
};

export const formatEmailAddress = (data) => {
  if (data.email) {
    data.emailAddress = data.email;
    delete data.email;
  }
};

export const formatAddressString = (data) => {
  data = data.filter((x) => x !== null && x !== undefined && x !== '');
  return data.join(' - ') || 'Unknown';
};

export const trimString = (data) => {
  if (typeof data === 'string') {
    return data.trim();
  }
  return data;
};
